import { atom } from 'recoil';

export const enchantingTabAtom = atom({
	key: 'enchantingTab',
	default: 'augmenting' as 'scrollcrafting' | 'augmenting' | 'enchanting' | 'scrapping',
});
